
import TextControl from './../../../../modules/TextControl'
import DateControl from './../../../../modules/DateControl'
import CheckboxControl from './../../../../modules/CheckboxControl'
import UnknownControl from './../../../../modules/UnknownControl'
import ListControl from './../../../../modules/ListControl'
import RadioControl from './../../../../modules/RadioControl'

const componentMap = {
  'text': TextControl,
  'date': DateControl,
  'checkbox': CheckboxControl,
  'list': ListControl,
  'radio': RadioControl,
}
export default componentMap

/**
 * Returns the component map but with any missing component types given
 * a default 'Unknown' component.
 * @param {Array<string>} types All the component types
 * @returns {object}
 */
export function shimMissingComponentTypes(types){
  const defaultTypes = [
    'header-one',
    'header-two',
    'header-three',
    'header-four',
    'header-five',
    'header-six',
    'unstyled',
  ]
  var newComponentMap = Object.assign({}, componentMap),
    changed = false
  types.forEach(type => {
    if (defaultTypes.includes(type) || newComponentMap[type])
      return
    newComponentMap[type] = UnknownControl
    changed = true
  })
  return changed ? newComponentMap : componentMap
}


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/componentMap.js